// PCRS scheme-check outcome states and the user-facing copy for each.
// Adjust the messages here — they are intentionally kept in one place.

export const PCRS_STATUS = {
  VALID: "VALID",
  INVALID: "INVALID",
  PRIVATE_SKIPPED: "PRIVATE_SKIPPED",
  NO_MEDICAL_CARD: "NO_MEDICAL_CARD",
  EXTENSION_MISSING: "EXTENSION_MISSING",
  CONNECTION_ERROR: "CONNECTION_ERROR",
};

// Private patients have no GMS entitlements, so the scheme check is skipped.
export const PRIVATE_FINANCIAL_CLASS = "01";

// Without a live PCRS web-service connection reviews are read-only — adding,
// editing (correction), cancelling and deregistering are all disabled.
export const PCRS_CONNECTION_REQUIRED_MESSAGE =
  "PCRS connection required — reviews are read-only until it reconnects.";

// A missing extension and an unreachable PCRS aren't listed here: the page
// shows features/pcrsExtension's install / connection notices instead.
export const PCRS_MESSAGES = {
  NO_MEDICAL_CARD: "Patient has no medical card.",
};

const PCRS_ERROR_TITLE = "PCRS Scheme Check Error";

// Map a scheme-check result to the title/message shown in PCRSStatusBar.
export const getPcrsErrorContent = (schemeCheck) => {
  const title = PCRS_ERROR_TITLE;

  switch (schemeCheck?.status) {
    case PCRS_STATUS.NO_MEDICAL_CARD:
      return { title, message: PCRS_MESSAGES.NO_MEDICAL_CARD };
    default:
      return {
        title,
        message: `This patient is not eligible for review, because their GMS number is not valid. Reason: ${
          schemeCheck?.invalidReason ?? ""
        }`,
      };
  }
};
